import { VersioningLine } from './versioning-line';

export class VersioningBanner {
  width: number;
  height: number;
  fallbackWebPath: string;
  versioningLine: VersioningLine;
  zipWebPath: string;

  constructor(data: any) {
    this.width = data.width;
    this.height = data.height;
    this.zipWebPath = data.zipWebPath;
    this.fallbackWebPath = data.fallbackWebPath;
    this.versioningLine = typeof data.versioningLine !== 'undefined' ? new VersioningLine(data.versioningLine) : new VersioningLine({});
  }
}
